import type { ComponentProps } from 'react'
import { Typography } from '@/components/ui/typography'

export function OrderHistoryMobileLabel({
  children,
}: Pick<ComponentProps<typeof Typography>, 'children'>) {
  return (
    <Typography variant="eyebrow" className="block md:hidden">
      {children}
    </Typography>
  )
}

export function CustomerLedgerHeaderCell({
  children,
  className = '',
}: Pick<ComponentProps<typeof Typography>, 'children' | 'className'>) {
  return (
    <Typography variant="eyebrow" tone="muted" weight="medium" className={className}>
      {children}
    </Typography>
  )
}
